import { FrequentRiderPoints, FrequentRiderProgram } from "@graphql/api";
import { formatWithLocale, formatTime } from "@hudson/ui/lib/date_fns_locale";
import useConfig from "@lib/use_config";
import useContent from "@lib/use_content";

interface TransactionTableProps {
  points: FrequentRiderPoints[];
  programs: FrequentRiderProgram[];
}

export default function TransactionTable({ points, programs }: TransactionTableProps) {
  const { data } = useConfig(["timeFormat"]);
  const { data: contentData, loading: contentLoading } = useContent([
    "beProfilePointsTableResidPrefix",
    "beProfilePointsTransactionsTitle",
  ]);

  const transactions = points
    .map((point) => point.transactions)
    .flat()
    .sort((a, b) => b.transactionDate.localeCompare(a.transactionDate))
    .map((point) => {
      const program = programs.find((p) => Number(p.id) === point.programId);
      return {
        id: point?.id,
        date: point.transactionDate,
        comments: point.comments,
        program: program?.name || "",
        description: point.description,
        resId: point.resId == 0 ? "" : point.resId,
        points: point.debitCredit == "C" ? `+${point.points}` : `-${point.points}`,
      };
    });

  return (
    <div>
      <h3 className="text-lg leading-6 font-semibold text-gray-900 mt-8">
        {contentData?.content.beProfilePointsTransactionsTitle}
      </h3>

      <div className="mt-3 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300 border-gray-300">
              <tbody className="divide-y divide-gray-200 bg-white">
                {transactions.map((transaction) => (
                  <tr key={transaction.id} className="even:bg-gray-50">
                    <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-0">
                      {formatWithLocale(transaction.date, "P")}{" "}
                      {formatTime(transaction.date, data?.config.timeFormat)}
                    </td>
                    <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                      {transaction.program}
                    </td>
                    <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
                      {transaction.description}
                    </td>
                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900">
                      {transaction.points}
                    </td>
                    <td className="whitespace-nowrap px-2 py-2 text-sm  text-gray-500 text-left">
                      {transaction.resId
                        ? `${contentData?.content.beProfilePointsTableResidPrefix} ${transaction.resId}`
                        : ""}
                    </td>
                    <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                      {transaction.comments}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
